"use client";
import { IcNotFoundPage } from "@/components/icons";
import { Button } from "@/components/ui";
import { INTERNAL_ROUTES } from "@/constants";
import { ArrowLeft } from "lucide-react";
import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();
  return (
    <div className="h-screen w-screen flex items-center justify-center p-4 bg-primary-hover">
      <div className="shadow-card flex flex-col items-center justify-center md:w-[540px] w-full py-12 gap-4 p-4 bg-white rounded-2xl">
        <IcNotFoundPage className="sm:w-[320px] w-[280px]" />
        <div className="space-y-3 flex flex-col items-center">
          <h1 className="font-bold text-3xl text-gray-900 text-center">Oops, page not found!</h1>
          <p className="text-gray-500 text-sm font-normal text-center">
            The page you requested could not found
          </p>
        </div>

        <Button
          onClick={() => router.push(INTERNAL_ROUTES.HOME)}
          variant="ghost"
          size={"lg"}
          className="text-sm font-semibold gap-2 mt-4"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Button>
      </div>
    </div>
  );
}
